<template>
  <div>
    <toggle-btn
      v-for="time in times"
      :key="time"
      block
      class="mb-2"
      :disabled="disabled"
      :label="time"
      :model-value="timeValue"
      :val="time"
      @update:model-value="setTime"
    />
  </div>
</template>

<script setup lang="ts">
import { DateTime } from '@quotetome/materials-api'
import ToggleBtn from '@/components/toggle-btn.vue'

export interface Props {
  disabled?: boolean
  modelValue?: DateTime | null
}

const props = withDefaults(defineProps<Props>(), {
  modelValue: null,
})
const emit = defineEmits(['update:delivery-time', 'update:model-value'])

const amHours = [8, 9, 10, 11].map(h => String(h).padStart(2, '0'))
const pmHours = [12, 1, 2, 3, 4, 5, 6, 7].map(h => String(h).padStart(2, '0'))
const minutes = ['00', '15', '30', '45']
const times: string[] = amHours.map(hour => minutes.map(minute => `${hour}:${minute} AM`)).flat().concat(
  pmHours.map(hour => minutes.map(minute => `${hour}:${minute} PM`)).flat()
)

const timeValue = computed(() => {
  if (!props.modelValue) {
    return ''
  }

  let hour = props.modelValue.toDate().getHours()

  if (hour > 12) {
    hour -= 12
  }

  const minute = String(props.modelValue.toDate().getMinutes()).padStart(2, '0')
  const amPm = (props.modelValue.toDate().getHours() ?? 0) >= 12 ? 'PM' : 'AM'

  return `${String(hour).padStart(2, '0')}:${minute} ${amPm}`
})

const setTime = (time: string) => {
  const [hourMinute, amPm] = time.split(' ')
  const [hour, minute] = hourMinute.split(':').map(Number)
  const offset = hour !== 12 && amPm === 'PM' ? 12 : 0

  const date = new DateTime(props.modelValue || undefined)
    .withHour(hour + offset)
    .withMinute(minute)
    .withSecond(0)
    .withMillisecond(0)


  emit('update:model-value', date)
  emit('update:delivery-time', 'sp')
}
</script>
